
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue'; 

import useProveedores from '../composables/useProveedores';

export default {
    components: {
        ProveedorEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/ProveedorEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerProveedores,
        } = useProveedores();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'NIT', value: 'nit', sortable: true },
            { text: 'Celular', value: 'celular', sortable: true },
            { text: 'Contacto', value: 'contacto', sortable: true },
            { text: 'Celular Contacto', value: 'celular_contacto', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let proveedores: any = [];
        const proveedoresFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const proveedorEditarComponentRef = ref();

        onMounted(async() => {
            await buscarProveedores();
        });

        const buscarProveedores = async () => {
            const resp = await obtenerProveedores(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                proveedores = resp.data;
                proveedoresFiltrados.value = JSON.parse(JSON.stringify(proveedores));
            }
        }

        const nuevoProveedor = async () => {
            proveedorEditarComponentRef.value.abrirComponent();
        }

        const editarProveedor = async (proveedor: any) => {
            proveedorEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(proveedor)));
        }

        const filtrarInformacion = async () => {
            proveedoresFiltrados.value = JSON.parse(JSON.stringify(
                proveedores.filter(
                    (u: any) => u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nit.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.celular.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.contacto.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.celular_contacto.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarProveedorEditarComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarProveedores();
            }
        }

        return {
            // products,
            fitroBusqueda,
            headers,
            textoFiltro,
            proveedoresFiltrados,

            buscarProveedores,
            editarProveedor,
            filtrarInformacion,
            nuevoProveedor,

            proveedorEditarComponentRef,
            cerrarProveedorEditarComponentEmit,
        };
    }
}
